import { QUERY_KEYS, soCaiColumns, theKhoColumns } from '@/constants';
import { InfoDropdown } from '@/components/custom/erp';

const PhieuXuatDieuChuyenInfoDropdown = ({ uuid, ma_ct }: { uuid: string; ma_ct?: string }) => (
  <InfoDropdown
    uuid={uuid}
    ma_ct={ma_ct}
    tableItems={[
      {
        title: 'Xem sổ kho',
        endpoint: QUERY_KEYS.SO_KHO,
        columns: theKhoColumns,
        group: 1
      },
      {
        title: 'Xem sổ cái',
        endpoint: QUERY_KEYS.SO_CAI,
        columns: soCaiColumns,
        group: 1
      }
    ]}
  />
);

export default PhieuXuatDieuChuyenInfoDropdown;
